<script setup lang='ts'>
import type { AUDIT_STATUS_CODE } from '@/shared/constants'

const props = withDefaults(defineProps<{
  status?: keyof typeof AUDIT_STATUS_CODE
}>(), {
  status: 0,
})
</script>

<template>
  <NTooltip v-if="props.status === -1" trigger="hover">
    <template #trigger>
      <i class="i-ep:circle-close-filled text-red-5" v-bind="$attrs" />
    </template>
    审核未通过
  </NTooltip>
  <NTooltip v-else-if="props.status === 1" trigger="hover">
    <template #trigger>
      <i class="i-ep:circle-check-filled text-green-5" v-bind="$attrs" />
    </template>
    审核通过
  </NTooltip>
  <NTooltip v-else trigger="hover">
    <template #trigger>
      <i v-bind="$attrs" class="i-ep:warning-filled text-gray-5" />
    </template>
    未审核
  </NTooltip>
</template>

<style lang='scss' scoped>
</style>
